import { useModal } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { getPolicyVersion, hasPromotionFinished } from '../../../../domain'
import { getFeatureToggles, useConfig } from '../../../../state/configuration'
import {
  OfferTermsModalContent,
  PromotionBannerActivated,
} from '../../organisms/promotion'
import { usePolicy } from '../policyContext'

export const PolicyPromotionBanner: FunctionComponent = () => {
  const modal = useModal()
  const { policy } = usePolicy()
  const { hidePromotionBanner } = useConfig(getFeatureToggles)

  const {
    quote: { promotion },
  } = getPolicyVersion(policy)

  const onOfferTermsClick = useCallback(() => {
    modal.show({
      content: <OfferTermsModalContent promoCode={promotion?.code ?? ''} />,
    })
  }, [modal, promotion])

  if (hidePromotionBanner || !promotion) {
    return null
  }

  return promotion?.isActive &&
    !hasPromotionFinished(promotion, policy.policyDetail.policyPeriodNumber) ? (
    <PromotionBannerActivated onOfferTermsClick={onOfferTermsClick} />
  ) : null
}
